import React from "react";
import { UseFormRegister, FieldError } from "react-hook-form";
import { filterFeet, filterInches } from "components/form-fields/height-field/heightFieldSchema";

interface HeightFieldProps {
    registerFeet: ReturnType<UseFormRegister<any>>;
    registerInches: ReturnType<UseFormRegister<any>>;
    errors?: FieldError;
    feetId?: string;
    inchesId?: string;
}

/**
 * Height input field with feet and inches
 */
const HeightField = ({ registerFeet, registerInches, errors, feetId, inchesId }: HeightFieldProps) => {
    const handleFeetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const filtered = filterFeet(e.target.value);
        if (filtered !== e.target.value) {
            e.target.value = filtered;
        }
        registerFeet.onChange(e);
    };

    const handleInchesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const filtered = filterInches(e.target.value);
        if (filtered !== e.target.value) {
            e.target.value = filtered;
        }
        registerInches.onChange(e);
    };

    return (
        <div className="form-control w-fit">
            <div className="label">
                <span className="text-base-content">Height</span>
            </div>
            <div className="flex gap-2">
                <div className="relative w-[60px] h-9">
                    <input
                        {...registerFeet}
                        id={feetId}
                        type="text"
                        placeholder="5"
                        className={`input input-bordered bg-base-100 text-sm w-[60px] h-9 py-0 pr-[25px] ${
                            errors ? "input-error" : ""
                        }`}
                        maxLength={1}
                        onChange={handleFeetChange}
                        aria-label="Height in feet"
                    />
                    <span className="absolute top-1/2 transform -translate-y-1/2 left-[30px] text-base-content opacity-60 pointer-events-none text-sm">
                        ft
                    </span>
                </div>
                <div className="relative w-[100px] h-9">
                    <input
                        {...registerInches}
                        id={inchesId}
                        type="text"
                        placeholder="8"
                        className={`input input-bordered bg-base-100 text-sm w-[100px] h-9 py-0 ${errors ? "input-error" : ""}`}
                        maxLength={2}
                        onChange={handleInchesChange}
                        aria-label="Height in inches"
                    />
                    <span className="absolute top-1/2 transform -translate-y-1/2 left-[38px] text-base-content opacity-60 pointer-events-none text-sm">
                        in
                    </span>
                </div>
            </div>
            {errors && <p className="text-error text-xs mt-1">{errors?.message}</p>}
        </div>
    );
};

export default HeightField;
